import { AppSettings } from './app.settings'
export class AgentSettings {
    public static AGENT_LOGIN = `${AppSettings.BASE_URL}/api/login/login`;

}